import { render } from "./Tech.vue?vue&type=template&id=0dfb69ba&ts=true"
import script from "./Tech.vue?vue&type=script&lang=ts"
export * from "./Tech.vue?vue&type=script&lang=ts"

import "./Tech.vue?vue&type=style&index=0&id=0dfb69ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__